import { contentCards } from '@/mocks/yy';

export default function Content() {
  return (
    <section id="content" className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
              <i className="ri-fire-line" aria-hidden="true"></i>
              热门内容推荐
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl text-foreground-950">当下最受欢迎的直播间</h2>
            <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              从才艺到游戏，从K歌到交友，精选当下热门内容，进入歪歪官方网站首页即可随时回看与互动。
            </p>
          </div>
          <a
            href="#guide"
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-secondary-100 text-secondary-900 text-sm whitespace-nowrap hover:bg-secondary-200 transition-colors"
          >
            查看观看方式
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {contentCards.map((c) => (
            <article key={c.title} className="group rounded-lg overflow-hidden border border-background-200 bg-background-100 hover:border-primary-200 transition-colors">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={c.image}
                  alt={c.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-foreground-950/60 text-background-50 text-xs">
                  <i className="ri-vidicon-line" aria-hidden="true"></i>
                  {c.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base text-foreground-950 leading-snug">{c.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}